if (!customElements.get('return-request-modal')) {
    customElements.define('return-request-modal', class ReturnRequestModal extends ModalDialog {
        constructor() {
            super();

            this.API_BASE = window.GD_API_BASE + '/shopify-sync';
            this.publicToken = null;

            this.selectors = {
                steps: '.js-return-modal-step',
                errorMessage: '.js-return-modal-error',
                itemsGroup: '.js-return-modal-items-group',
                itemsList: '.js-return-modal-items-list',
                reviewButton: '.js-return-modal-review-button',
                submitButton: '.js-return-modal-submit-button',
                summary: '.js-return-modal-summary',
                backToPhotosButton: '.js-return-modal-back-to-photos',
                backToReasonButton: '.js-return-modal-back-to-reason',
                backToItemButton: '.js-return-modal-back-to-item',
                nextToReasonButton: '.js-return-modal-next-to-reason',
                nextToPhotosButton: '.js-return-modal-next-to-photos',
                notEligibleReason: '.js-return-modal-not-eligible-reason',
                successText: '.js-return-modal-success-text',
                successReturnId: '.js-return-modal-success-return-id',
                uploadDropzone: '.js-return-modal-upload-dropzone',
                uploadInput: '.js-return-modal-upload-input',
                uploadPreviews: '.js-return-modal-upload-previews',
                itemsError: '.js-return-modal-items-error',
                reasonError: '.js-return-modal-reason-error',
                detailsError: '.js-return-modal-details-error',
                uploadError: '.js-return-modal-upload-error',
                reasonRadios: '.js-return-modal-reasons',
                suboptionSets: '.js-return-modal-suboptions',
                suboptionError: '.js-return-modal-suboption-error',
                detailsGroup: '.js-return-modal-details-group',
                ratingContainer: '.js-return-modal-rating',
                ratingStars: '.js-return-modal-rating-stars',
                ratingFeedback: '.js-return-modal-rating-feedback',
                ratingThankyou: '.js-return-modal-rating-thankyou',
                ratingTrustpilot: '.js-return-modal-rating-trustpilot',
                ratingSubmitBtn: '.js-return-modal-rating-submit'
            };

            this.classes = {
                hidden: 'hidden',
                active: 'active',
                loading: 'loading',
                isHidden: 'is-hidden'
            };

            this.orderData = null;
            this.selectedFiles = [];
            this.uploadedPhotoKeys = [];
            this.fileUploadStatus = new Map(); // file -> { status: 'pending'|'uploaded'|'failed', key: string|null }
            this.eligibleLineItems = [];
            this.MAX_FILES = 5;
            this.selectedRating = 0;
            this.submittedReturnId = null;

            this.errorMessage = this.querySelector(this.selectors.errorMessage);
            this.reviewButton = this.querySelector(this.selectors.reviewButton);
            this.submitButton = this.querySelector(this.selectors.submitButton);
            this.summaryContainer = this.querySelector(this.selectors.summary);
            this.backToPhotosButton = this.querySelector(this.selectors.backToPhotosButton);
            this.backToReasonButton = this.querySelector(this.selectors.backToReasonButton);
            this.backToItemButton = this.querySelector(this.selectors.backToItemButton);
            this.nextToReasonButton = this.querySelector(this.selectors.nextToReasonButton);
            this.nextToPhotosButton = this.querySelector(this.selectors.nextToPhotosButton);
            this.notEligibleReason = this.querySelector(this.selectors.notEligibleReason);
            this.successText = this.querySelector(this.selectors.successText);
            this.successReturnId = this.querySelector(this.selectors.successReturnId);
            this.itemsGroup = this.querySelector(this.selectors.itemsGroup);
            this.itemsList = this.querySelector(this.selectors.itemsList);
            this.uploadDropzone = this.querySelector(this.selectors.uploadDropzone);
            this.uploadInput = this.querySelector(this.selectors.uploadInput);
            this.uploadPreviews = this.querySelector(this.selectors.uploadPreviews);
            this.itemsError = this.querySelector(this.selectors.itemsError);
            this.reasonError = this.querySelector(this.selectors.reasonError);
            this.detailsError = this.querySelector(this.selectors.detailsError);
            this.uploadError = this.querySelector(this.selectors.uploadError);
            this.reasonRadios = this.querySelector(this.selectors.reasonRadios);
            this.suboptionSets = Array.from(this.querySelectorAll(this.selectors.suboptionSets));
            this.suboptionError = this.querySelector(this.selectors.suboptionError);
            this.detailsGroup = this.querySelector(this.selectors.detailsGroup);
            this.ratingContainer = this.querySelector(this.selectors.ratingContainer);
            this.ratingStars = this.querySelector(this.selectors.ratingStars);
            this.ratingFeedback = this.querySelector(this.selectors.ratingFeedback);
            this.ratingThankyou = this.querySelector(this.selectors.ratingThankyou);
            this.ratingTrustpilot = this.querySelector(this.selectors.ratingTrustpilot);
            this.ratingSubmitBtn = this.querySelector(this.selectors.ratingSubmitBtn);

            this.handleReview = this.handleReview.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.handleBackToPhotos = this.handleBackToPhotos.bind(this);
            this.handleBackToReason = this.handleBackToReason.bind(this);
            this.handleBackToItem = this.handleBackToItem.bind(this);
            this.handleNextToReason = this.handleNextToReason.bind(this);
            this.handleNextToPhotos = this.handleNextToPhotos.bind(this);
            this.handleUploadClick = this.handleUploadClick.bind(this);
            this.handleFileChange = this.handleFileChange.bind(this);
            this.openForOrder = this.openForOrder.bind(this);
            this.handleItemChange = this.handleItemChange.bind(this);
            this.handleReasonSelectChange = this.handleReasonSelectChange.bind(this);
            this.handleSuboptionChange = this.handleSuboptionChange.bind(this);
            this.handleDetailsInput = this.handleDetailsInput.bind(this);
            this.handleHeaderBack = this.handleHeaderBack.bind(this);
            this.handleStepperClick = this.handleStepperClick.bind(this);
            this.handleStarClick = this.handleStarClick.bind(this);
            this.handleStarHover = this.handleStarHover.bind(this);
            this.handleStarLeave = this.handleStarLeave.bind(this);
            this.handleRatingSubmit = this.handleRatingSubmit.bind(this);
        }

        connectedCallback() {
            super.connectedCallback();

            this.reviewButton?.addEventListener('click', this.handleReview);
            this.submitButton?.addEventListener('click', this.handleSubmit);
            this.backToPhotosButton?.addEventListener('click', this.handleBackToPhotos);
            this.backToReasonButton?.addEventListener('click', this.handleBackToReason);
            this.backToItemButton?.addEventListener('click', this.handleBackToItem);
            this.nextToReasonButton?.addEventListener('click', this.handleNextToReason);
            this.nextToPhotosButton?.addEventListener('click', this.handleNextToPhotos);
            this.uploadDropzone?.addEventListener('click', this.handleUploadClick);
            this.uploadInput?.addEventListener('change', this.handleFileChange);
            document.addEventListener('return-request-modal:open', this.openForOrder);

            this.itemsList?.addEventListener('change', this.handleItemChange);
            this.reasonRadios?.addEventListener('change', this.handleReasonSelectChange);
            this.querySelector('textarea[name="details"]')?.addEventListener('input', this.handleDetailsInput);
            this.querySelector('.js-return-modal-header-back')?.addEventListener('click', this.handleHeaderBack);
            this.querySelectorAll('.return-modal__stepper').forEach(s => s.addEventListener('click', this.handleStepperClick));

            // rating widget events
            this.querySelectorAll('.js-return-modal-star').forEach(star => {
                star.addEventListener('click', this.handleStarClick);
                star.addEventListener('mouseenter', this.handleStarHover);
                star.addEventListener('mouseleave', this.handleStarLeave);
            });
            this.ratingSubmitBtn?.addEventListener('click', this.handleRatingSubmit);

            // start with Next button disabled on reason step
            this.nextToPhotosButton?.setAttribute('disabled', '');

            // apply dynamic timeline text from config
            const cfg = window.ReturnTimelineConfig;
            if (cfg) {
                const reviewEl = this.querySelector('.js-return-review-timeline');
                if (reviewEl) reviewEl.textContent = cfg.reviewTimeline;
            }
        }

        disconnectedCallback() {
            this.reviewButton?.removeEventListener('click', this.handleReview);
            this.submitButton?.removeEventListener('click', this.handleSubmit);
            this.backToPhotosButton?.removeEventListener('click', this.handleBackToPhotos);
            this.backToReasonButton?.removeEventListener('click', this.handleBackToReason);
            this.backToItemButton?.removeEventListener('click', this.handleBackToItem);
            this.nextToReasonButton?.removeEventListener('click', this.handleNextToReason);
            this.nextToPhotosButton?.removeEventListener('click', this.handleNextToPhotos);
            this.uploadDropzone?.removeEventListener('click', this.handleUploadClick);
            this.uploadInput?.removeEventListener('change', this.handleFileChange);
            document.removeEventListener('return-request-modal:open', this.openForOrder);
            this.itemsList?.removeEventListener('change', this.handleItemChange);
            this.reasonRadios?.removeEventListener('change', this.handleReasonSelectChange);
            this.querySelector('textarea[name="details"]')?.removeEventListener('input', this.handleDetailsInput);
            this.querySelector('.js-return-modal-header-back')?.removeEventListener('click', this.handleHeaderBack);
            this.querySelectorAll('.return-modal__stepper').forEach(s => s.removeEventListener('click', this.handleStepperClick));
            this.querySelectorAll('.js-return-modal-star').forEach(star => {
                star.removeEventListener('click', this.handleStarClick);
                star.removeEventListener('mouseenter', this.handleStarHover);
                star.removeEventListener('mouseleave', this.handleStarLeave);
            });
            this.ratingSubmitBtn?.removeEventListener('click', this.handleRatingSubmit);
        }

        hide() {
            this.toggleError('', true);
            this.clearAllFieldErrors();
            this.resetForm();
            this._unlockScroll();
            super.hide();
        }

        resetForm() {
            this.orderData = null;
            this.selectedFiles = [];
            this.uploadedPhotoKeys = [];
            this.fileUploadStatus.clear();
            this.eligibleLineItems = [];

            this.selectedRating = 0;
            this.submittedReturnId = null;
            this.resetRatingWidget();

            if (this.uploadPreviews) this.uploadPreviews.innerHTML = '';
            if (this.itemsList) this.itemsList.innerHTML = '';
            if (this.reasonRadios) {
                this.reasonRadios.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
            }
            this.suboptionSets.forEach(set => {
                set.classList.add(this.classes.hidden);
                set.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
            });
            if (this.detailsGroup) this.detailsGroup.classList.add(this.classes.hidden);

            const detailsTextarea = this.querySelector('textarea[name="details"]');
            if (detailsTextarea) detailsTextarea.value = '';
            this.nextToPhotosButton?.setAttribute('disabled', '');

            this.updateDropzoneVisibility();
            this.goToStep('checking');
        }

        openForOrder(event) {
            const { orderData, opener } = event.detail || {};
            this.orderData = orderData;
            // token mode: a cs-minted return link identifies the order server
            // side, so every api call goes through the public endpoints
            this.publicToken = (orderData && orderData.public_token) || null;
            this.updateTitleWithOrder();
            this.show(opener);
            this._lockScroll();
            this.checkEligibility();
        }

        // "Return Request #191815" -- the flow is always order-scoped, so the
        // title carries the order for both the account popup and the page
        updateTitleWithOrder() {
            const titleEl = this.querySelector('.return-modal__title');
            const orderName = this.orderData && this.orderData.order_name;
            if (!titleEl || !orderName) return;
            if (!titleEl.dataset.baseTitle) {
                titleEl.dataset.baseTitle = titleEl.textContent.trim();
            }
            const name = String(orderName);
            titleEl.textContent = `${titleEl.dataset.baseTitle} ${name.startsWith('#') ? name : `#${name}`}`;
        }

        _lockScroll() {
            this._scrollY = window.scrollY;
            document.documentElement.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this._scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
        }

        _unlockScroll() {
            const scrollY = this._scrollY || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.documentElement.style.overflow = '';
            window.scrollTo({ top: scrollY, behavior: 'instant' });
        }

        goToStep(stepName, direction) {
            const prevIndex = this.formSteps.indexOf(this.currentStep);
            const nextIndex = this.formSteps.indexOf(stepName);
            const isBack = direction === 'back' || (direction == null && nextIndex !== -1 && prevIndex !== -1 && nextIndex < prevIndex);

            const steps = this.querySelectorAll(this.selectors.steps);
            steps.forEach(step => {
                const isTarget = step.dataset.step === stepName;
                // remove animation classes first
                step.classList.remove('slide-back');
                step.style.animation = 'none';
                step.classList.toggle(this.classes.active, isTarget);
                if (isTarget) {
                    // force reflow to restart animation
                    step.offsetHeight;
                    step.style.animation = '';
                    if (isBack) step.classList.add('slide-back');
                }
            });
            this.currentStep = stepName;
            this.updateHeaderBack();
        }

        // ordered form steps for back navigation
        get formSteps() {
            return ['select-item', 'select-reason', 'upload-photos', 'confirm'];
        }

        updateHeaderBack() {
            const backBtn = this.querySelector('.js-return-modal-header-back');
            if (!backBtn) return;
            const idx = this.formSteps.indexOf(this.currentStep);
            // show back button only on form steps after the first one
            if (idx > 0) {
                backBtn.classList.remove('hidden');
            } else {
                backBtn.classList.add('hidden');
            }
        }

        handleHeaderBack() {
            const idx = this.formSteps.indexOf(this.currentStep);
            if (idx > 0) {
                this.goToStep(this.formSteps[idx - 1]);
            }
        }

        handleStepperClick(e) {
            const stepperItem = e.target.closest('.return-modal__stepper-item');
            if (!stepperItem) return;

            const stepperItems = Array.from(stepperItem.parentElement.children).filter(
                el => el.classList.contains('return-modal__stepper-item')
            );
            const clickedIndex = stepperItems.indexOf(stepperItem);
            const currentIndex = this.formSteps.indexOf(this.currentStep);

            // only allow navigating to completed (earlier) steps
            if (clickedIndex < currentIndex && clickedIndex >= 0) {
                this.goToStep(this.formSteps[clickedIndex]);
            }
        }

        toggleError(message = '', isHidden = true) {
            if (!this.errorMessage) return;
            this.errorMessage.textContent = message;
            this.errorMessage.classList.toggle(this.classes.hidden, isHidden);
            if (!isHidden) {
                this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }

        toggleFieldError(element, message, isHidden = true) {
            if (!element) return;
            element.textContent = message;
            element.classList.toggle(this.classes.hidden, isHidden);
            if (!isHidden) {
                element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }

        clearAllFieldErrors() {
            this.toggleFieldError(this.itemsError, '', true);
            this.toggleFieldError(this.reasonError, '', true);
            this.toggleFieldError(this.detailsError, '', true);
            this.toggleFieldError(this.uploadError, '', true);
        }

        handleItemChange() {
            this.toggleFieldError(this.itemsError, '', true);
        }

        getSelectedReason() {
            // suboption radios are nested inside the reasons container, so
            // the query must target reason radios specifically
            const checked = this.reasonRadios?.querySelector('.js-return-modal-reason-radio:checked');
            return checked?.value || '';
        }

        handleReasonSelectChange(event) {
            // suboption radios bubble through the same container; a suboption
            // pick only clears its own error and never rebuilds the sets
            if (event?.target?.classList?.contains('js-return-modal-suboption-radio')) {
                this.handleSuboptionChange();
                return;
            }

            const reason = this.getSelectedReason();
            this.toggleFieldError(this.reasonError, '', true);
            this.toggleFieldError(this.suboptionError, '', true);
            this.updateSuboptionSets(reason);

            // show details textarea whenever a reason is selected
            if (reason) {
                this.detailsGroup?.classList.remove(this.classes.hidden);
                this.updateDetailsPlaceholder(reason);
            } else {
                this.detailsGroup?.classList.add(this.classes.hidden);
            }

            // clear details error when reason changes
            this.toggleFieldError(this.detailsError, '', true);
            this.updateNextToPhotosButton();
        }

        handleSuboptionChange() {
            this.toggleFieldError(this.suboptionError, '', true);
        }

        reasonHasSuboptions(reason) {
            return this.suboptionSets.some(set => set.dataset.reason === reason);
        }

        updateSuboptionSets(reason) {
            this.suboptionSets.forEach(set => {
                const matches = set.dataset.reason === reason;
                set.classList.toggle(this.classes.hidden, !matches);
                if (!matches) {
                    // a stale pick from another reason must never survive a
                    // reason switch into the submit payload
                    set.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
                }
            });
        }

        getSelectedSuboption() {
            const reason = this.getSelectedReason();
            const activeSet = this.suboptionSets.find(set => set.dataset.reason === reason);
            const checked = activeSet?.querySelector('input[type="radio"]:checked');
            return checked?.value || '';
        }

        handleDetailsInput() {
            this.toggleFieldError(this.detailsError, '', true);
            this.updateNextToPhotosButton();
        }

        updateNextToPhotosButton() {
            if (!this.nextToPhotosButton) return;
            const reason = this.getSelectedReason();
            if (reason) {
                this.nextToPhotosButton.removeAttribute('disabled');
            } else {
                this.nextToPhotosButton.setAttribute('disabled', '');
            }
        }

        updateDetailsPlaceholder(reason) {
            const detailsTextarea = this.querySelector('textarea[name="details"]');
            if (!detailsTextarea) return;

            const placeholderMap = {
                TECHNICAL_ISSUE: rt('placeholder_technical'),
                EXPECTATIONS: rt('placeholder_expectations'),
                SPACE: rt('placeholder_space'),
                DAMAGED_IN_SHIPPING: rt('placeholder_damaged'),
                NO_LONGER_NEEDED: rt('placeholder_no_longer_needed'),
                WRONG_ITEM: rt('placeholder_wrong_item')
            };

            detailsTextarea.placeholder = placeholderMap[reason] || rt('placeholder_default');
        }

        async getToken() {
            return window.ReturnsUtils.getToken();
        }

        async apiCall(url, options = {}, retry = true) {
            if (this.publicToken) {
                // anonymous public endpoints: no customer jwt, no refresh loop
                return fetch(url, options);
            }
            return window.ReturnsUtils.apiCall(url, options, retry);
        }

        publicEndpoint(suffix) {
            const base = window.GD_PUBLIC_API_BASE || 'https://coach.golfdaddyapi.com';
            return `${base}/public/return-links/${encodeURIComponent(this.publicToken)}${suffix}`;
        }

        async requestPresignedUrl(contentType) {
            if (this.publicToken) {
                return this.apiCall(this.publicEndpoint('/presigned-url'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ contentType })
                });
            }
            const presignApiBase = window.GD_API_BASE || 'https://api.golfdaddyapi.com';
            return this.apiCall(`${presignApiBase}/s3/presigned-url`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    uploadContext: 'CUSTOMER_SUPPORT_ATTACHMENTS',
                    contentType
                })
            });
        }

        checkEligibility() {
            this.toggleError('', true);

            const order = this.orderData;
            if (!order) {
                this.showNotEligible(rt('order_data_unavailable'));
                return;
            }

            const allItems = order.line_items || [];
            this.eligibleLineItems = allItems.filter(item => {
                const title = (item.title || '').toLowerCase();
                const sku = String(item.sku || '').toUpperCase();
                if (sku.startsWith('NVDPROTECTION')) return false;
                if (title.includes('shipping protection') || title.includes('shipping-protection')) return false;
                if (title.includes('subscription') || title.includes('membership')) return false;
                if (String(item.requires_shipping) === 'false') return false;
                return true;
            });

            this.shopifyOrderId = String(order.order_id);
            this.shopifyOrderName = order.order_name;
            this.populateItems(this.eligibleLineItems);
            this.goToStep('select-item');

            if (order.has_shipping_protection) {
                this.showShippingProtectionBanner();
            }
        }

        showShippingProtectionBanner() {
            const itemsGroup = this.querySelector('.js-return-modal-items-group');
            if (!itemsGroup) return;

            // remove any existing banner before inserting
            const existing = this.querySelector('.return-modal__protection-banner');
            if (existing) existing.remove();

            const banner = document.createElement('div');
            banner.className = 'return-modal__protection-banner';
            banner.innerHTML = `
                <svg class="return-modal__protection-banner-icon" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2L3 5V9C3 13.4 6.2 17.5 10 18.5C13.8 17.5 17 13.4 17 9V5L10 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M7 10L9 12L13 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>${rt('shipping_protection_banner')}</span>
            `;

            itemsGroup.parentNode.insertBefore(banner, itemsGroup);
        }

        showNotEligible(message) {
            if (this.notEligibleReason) {
                this.notEligibleReason.textContent = message;
            }
            this.goToStep('not-eligible');
        }

        populateItems(lineItems) {
            if (!this.itemsList) return;
            this.itemsList.innerHTML = '';

            lineItems.forEach((item, index) => {
                const label = document.createElement('label');
                label.className = 'return-modal__item-checkbox';

                const checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.name = 'return_items';
                checkbox.value = item.line_item_id || item.id || index;
                checkbox.dataset.title = item.title || item.name || '';
                checkbox.dataset.variantTitle = item.variant_title || '';
                checkbox.dataset.maxQuantity = item.quantity || 1;

                const info = document.createElement('div');
                info.className = 'return-modal__item-checkbox-info';

                const nameEl = document.createElement('span');
                nameEl.className = 'return-modal__item-checkbox-name';
                nameEl.textContent = item.title || item.name || '';

                info.appendChild(nameEl);

                if (item.variant_title && item.variant_title !== 'Default Title') {
                    const variantEl = document.createElement('span');
                    variantEl.className = 'return-modal__item-checkbox-variant';
                    variantEl.textContent = item.variant_title;
                    info.appendChild(variantEl);
                }

                label.appendChild(checkbox);

                const imageSrc = typeof item.image === 'string' ? item.image : item.image?.src;
                if (imageSrc) {
                    const img = document.createElement('img');
                    img.className = 'return-modal__item-checkbox-image';
                    img.src = imageSrc;
                    img.alt = item.title || '';
                    label.appendChild(img);
                }

                label.appendChild(info);

                if ((item.quantity || 1) > 1) {
                    const stepper = document.createElement('div');
                    stepper.className = 'return-modal__qty-stepper hidden';

                    const minusBtn = document.createElement('button');
                    minusBtn.type = 'button';
                    minusBtn.className = 'return-modal__qty-btn';
                    minusBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 6h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
                    minusBtn.disabled = true;

                    const qtyInput = document.createElement('input');
                    qtyInput.type = 'number';
                    qtyInput.className = 'return-modal__qty-input';
                    qtyInput.min = '1';
                    qtyInput.max = String(item.quantity);
                    qtyInput.value = '1';

                    const plusBtn = document.createElement('button');
                    plusBtn.type = 'button';
                    plusBtn.className = 'return-modal__qty-btn';
                    plusBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2.5v7M2.5 6h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

                    const maxLabel = document.createElement('span');
                    maxLabel.className = 'return-modal__qty-max';
                    maxLabel.textContent = rt('of_qty', { quantity: item.quantity });

                    stepper.appendChild(minusBtn);
                    stepper.appendChild(qtyInput);
                    stepper.appendChild(plusBtn);
                    stepper.appendChild(maxLabel);

                    const updateQtyBtnStates = () => {
                        const val = parseInt(qtyInput.value, 10);
                        minusBtn.disabled = val <= 1;
                        plusBtn.disabled = val >= item.quantity;
                    };

                    minusBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const val = parseInt(qtyInput.value, 10);
                        if (val > 1) qtyInput.value = String(val - 1);
                        updateQtyBtnStates();
                    });

                    plusBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const val = parseInt(qtyInput.value, 10);
                        if (val < item.quantity) qtyInput.value = String(val + 1);
                        updateQtyBtnStates();
                    });

                    qtyInput.addEventListener('change', () => updateQtyBtnStates());
                    updateQtyBtnStates();

                    checkbox.addEventListener('change', () => {
                        if (checkbox.checked) {
                            stepper.classList.remove('hidden');
                        } else {
                            stepper.classList.add('hidden');
                            qtyInput.value = '1';
                        }
                    });

                    label.appendChild(stepper);
                }

                this.itemsList.appendChild(label);
            });
        }

        handleNextToReason() {
            this.toggleError('', true);
            this.toggleFieldError(this.itemsError, '', true);

            const selected = this.itemsList?.querySelector('input[name="return_items"]:checked');
            if (!selected) {
                this.toggleFieldError(this.itemsError, rt('error_select_item'), false);
                return;
            }

            this.goToStep('select-reason');
        }

        handleNextToPhotos() {
            this.toggleError('', true);
            this.toggleFieldError(this.reasonError, '', true);
            this.toggleFieldError(this.suboptionError, '', true);
            this.toggleFieldError(this.detailsError, '', true);

            const reason = this.getSelectedReason();
            if (!reason) {
                this.toggleFieldError(this.reasonError, rt('error_select_reason'), false);
                return;
            }

            if (this.reasonHasSuboptions(reason) && !this.getSelectedSuboption()) {
                this.toggleFieldError(this.suboptionError, rt('error_select_suboption'), false);
                return;
            }

            this.goToStep('upload-photos');
        }

        handleReview() {
            this.toggleError('', true);
            this.toggleFieldError(this.uploadError, '', true);

            if (this.selectedFiles.length === 0) {
                this.toggleFieldError(this.uploadError, rt('error_upload_photo'), false);
                return;
            }

            const formData = this.getFormData();
            this.buildSummary(formData);
            this.goToStep('confirm');
        }

        handleBackToItem() {
            this.goToStep('select-item');
        }

        handleBackToReason() {
            this.goToStep('select-reason');
        }

        handleBackToPhotos() {
            this.goToStep('upload-photos');
        }

        handleUploadClick() {
            this.uploadInput?.click();
        }

        handleFileChange(event) {
            const files = Array.from(event.target.files || []);
            const combined = this.selectedFiles.concat(files);

            if (combined.length > this.MAX_FILES) {
                this.selectedFiles = combined.slice(0, this.MAX_FILES);
                this.toggleFieldError(this.uploadError, `Maximum ${this.MAX_FILES} files allowed. Only the first ${this.MAX_FILES} were kept.`, false);
            } else {
                this.selectedFiles = combined;
                this.toggleFieldError(this.uploadError, '', true);
            }

            // reset input so the same file can be re-selected
            this.uploadInput.value = '';
            this.renderPreviews();
        }

        async uploadFilesInBackground(newFiles) {

            for (const file of newFiles) {
                if (!this.selectedFiles.includes(file)) continue; // was removed before upload started
                const existing = this.fileUploadStatus.get(file);
                if (existing?.status === 'uploaded') continue;

                this.fileUploadStatus.set(file, { status: 'uploading', key: null });
                this.renderPreviews();

                try {
                    const contentType = this.getFileContentType(file);
                    const presignedRes = await this.requestPresignedUrl(contentType);

                    if (!presignedRes.ok) {
                        this.fileUploadStatus.set(file, { status: 'failed', key: null });
                        this.renderPreviews();
                        continue;
                    }

                    const presignedData = await presignedRes.json();
                    const { presignedUrl, key } = presignedData.data || {};

                    await this.uploadFileToS3(presignedUrl, file);
                    this.fileUploadStatus.set(file, { status: 'uploaded', key });
                    this.renderPreviews();
                } catch (error) {
                    this.fileUploadStatus.set(file, { status: 'failed', key: null });
                    this.renderPreviews();
                }
            }

        }

        updateDropzoneVisibility() {
            if (!this.uploadDropzone) return;
            if (this.selectedFiles.length >= this.MAX_FILES) {
                this.uploadDropzone.style.display = 'none';
            } else {
                this.uploadDropzone.style.display = '';
            }
        }

        renderPreviews() {
            if (!this.uploadPreviews) return;
            this.uploadPreviews.innerHTML = '';

            this.selectedFiles.forEach((file, index) => {
                const wrapper = document.createElement('div');
                wrapper.className = 'return-modal__upload-preview';

                const status = this.fileUploadStatus.get(file);
                if (status?.status === 'uploaded') {
                    wrapper.classList.add('return-modal__upload-preview--uploaded');
                } else if (status?.status === 'failed') {
                    wrapper.classList.add('return-modal__upload-preview--failed');
                } else if (status?.status === 'uploading') {
                    wrapper.classList.add('return-modal__upload-preview--uploading');
                    const spinner = document.createElement('div');
                    spinner.className = 'return-modal__upload-preview-spinner';
                    spinner.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" stroke-width="3"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" stroke-width="3" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/></path></svg>';
                    wrapper.appendChild(spinner);
                }

                const objectUrl = URL.createObjectURL(file);

                const ext = file.name.split('.').pop().toLowerCase();
                const unsupportedVideoExts = ['avi', 'mkv', 'wmv', 'flv'];
                const videoExts = ['mov', 'webm', 'mp4', 'm4v', '3gp', ...unsupportedVideoExts];
                const isVideo = file.type.startsWith('video/') || videoExts.includes(ext);
                const videoPlaceholderHtml = '<div class="return-modal__upload-preview-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 10l5-3v10l-5-3V10z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="3" y="6" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/></svg><span>' + ext.toUpperCase() + '</span></div>';

                if (isVideo && unsupportedVideoExts.includes(ext)) {
                    wrapper.classList.add('return-modal__upload-preview--no-thumb');
                    wrapper.insertAdjacentHTML('afterbegin', videoPlaceholderHtml);
                } else if (isVideo) {
                    // use inline <video> as preview — canvas thumbnail extraction
                    // fails on iOS Safari due to blob URL restrictions
                    const vid = document.createElement('video');
                    vid.src = objectUrl;
                    vid.muted = true;
                    vid.playsInline = true;
                    vid.preload = 'metadata';
                    vid.style.width = '100%';
                    vid.style.height = '100%';
                    vid.style.objectFit = 'cover';
                    vid.style.borderRadius = 'inherit';
                    vid.style.pointerEvents = 'none';
                    // show placeholder while loading
                    wrapper.classList.add('return-modal__upload-preview--no-thumb');
                    wrapper.insertAdjacentHTML('afterbegin', videoPlaceholderHtml);
                    vid.addEventListener('loadeddata', () => {
                        wrapper.classList.remove('return-modal__upload-preview--no-thumb');
                        const placeholder = wrapper.querySelector('.return-modal__upload-preview-placeholder');
                        if (placeholder) placeholder.remove();
                        wrapper.insertAdjacentElement('afterbegin', vid);
                    });
                    vid.addEventListener('error', () => {
                        // keep the placeholder icon if video can't load
                    });
                } else {
                    const fileExt = file.name.split('.').pop().toUpperCase();
                    const filePlaceholderHtml = '<div class="return-modal__upload-preview-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + fileExt + '</span></div>';
                    wrapper.classList.add('return-modal__upload-preview--no-thumb');
                    wrapper.insertAdjacentHTML('afterbegin', filePlaceholderHtml);
                    const img = document.createElement('img');
                    img.src = objectUrl;
                    img.alt = file.name;
                    img.addEventListener('load', () => {
                        wrapper.classList.remove('return-modal__upload-preview--no-thumb');
                        const placeholder = wrapper.querySelector('.return-modal__upload-preview-placeholder');
                        if (placeholder) placeholder.remove();
                        wrapper.insertAdjacentElement('afterbegin', img);
                    });
                }

                // open lightbox on thumbnail click
                wrapper.addEventListener('click', (e) => {
                    if (e.target.closest('.return-modal__upload-preview-remove') ||
                        e.target.closest('.return-modal__upload-preview-retry')) return;
                    this.openLightbox(file, objectUrl);
                });

                // show green tick for uploaded files
                if (status?.status === 'uploaded') {
                    const tick = document.createElement('span');
                    tick.className = 'return-modal__upload-preview-tick';
                    tick.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#22c55e"/><path d="M5 8l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                    wrapper.appendChild(tick);
                }

                // show retry button for failed files
                if (status?.status === 'failed') {
                    const retryBtn = document.createElement('button');
                    retryBtn.className = 'return-modal__upload-preview-retry';
                    retryBtn.type = 'button';
                    retryBtn.title = rt('retry_upload_title');
                    retryBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 7a5.5 5.5 0 1 1 1.1 3.3" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/><path d="M1 4v3.5h3.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                    retryBtn.addEventListener('click', async () => {
                        await this.retrySingleUpload(file);
                    });
                    wrapper.appendChild(retryBtn);
                }

                // only allow removing files that haven't been uploaded yet
                if (!status || status.status !== 'uploaded') {
                    const removeBtn = document.createElement('button');
                    removeBtn.className = 'return-modal__upload-preview-remove';
                    removeBtn.type = 'button';
                    removeBtn.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>';
                    removeBtn.addEventListener('click', () => {
                        this.fileUploadStatus.delete(file);
                        this.selectedFiles.splice(index, 1);
                        this.toggleFieldError(this.uploadError, '', true);
                        this.renderPreviews();
                    });
                    wrapper.appendChild(removeBtn);
                }

                this.uploadPreviews.appendChild(wrapper);
            });

            this.updateDropzoneVisibility();
        }

        _generateVideoThumbnail(objectUrl, wrapper, placeholderHtml) {
            // show placeholder immediately while we attempt to extract a frame
            wrapper.classList.add('return-modal__upload-preview--no-thumb');
            wrapper.insertAdjacentHTML('afterbegin', placeholderHtml);

            const video = document.createElement('video');
            video.src = objectUrl;
            video.muted = true;
            video.playsInline = true;
            video.preload = 'auto';
            // no crossOrigin on blob URLs — iOS Safari taints the canvas otherwise
            video.style.display = 'none';

            let seekAttempts = 0;
            const maxSeekAttempts = 3;
            const seekTimes = [0.5, 1.0, 0.0];
            let settled = false;

            const cleanup = () => {
                if (settled) return;
                settled = true;
                video.remove();
            };

            // timeout fallback — iOS may never fire loadeddata/seeked
            const timeout = setTimeout(cleanup, 4000);

            const tryCapture = () => {
                if (settled) return;
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth || 160;
                    canvas.height = video.videoHeight || 120;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                    // check if the frame is mostly black
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const data = imageData.data;
                    let brightPixels = 0;
                    const sampleStep = 16; // sample every 16th pixel for performance
                    for (let i = 0; i < data.length; i += 4 * sampleStep) {
                        if (data[i] > 20 || data[i + 1] > 20 || data[i + 2] > 20) {
                            brightPixels++;
                        }
                    }
                    const totalSampled = Math.ceil(data.length / (4 * sampleStep));
                    const isBlack = brightPixels / totalSampled < 0.05;

                    if (isBlack && seekAttempts < maxSeekAttempts) {
                        seekAttempts++;
                        video.currentTime = seekTimes[seekAttempts] || 0;
                        return; // will trigger another seeked event
                    }

                    if (!isBlack) {
                        const img = document.createElement('img');
                        img.src = canvas.toDataURL('image/jpeg', 0.7);
                        img.alt = rt('video_thumbnail_alt');
                        wrapper.classList.remove('return-modal__upload-preview--no-thumb');
                        const placeholder = wrapper.querySelector('.return-modal__upload-preview-placeholder');
                        if (placeholder) placeholder.remove();
                        wrapper.insertAdjacentElement('afterbegin', img);
                    }
                    clearTimeout(timeout);
                    cleanup();
                } catch (_e) {
                    // canvas tainted or other error -- keep placeholder (video icon + extension label)
                    clearTimeout(timeout);
                    cleanup();
                }
            };

            video.addEventListener('seeked', tryCapture);
            video.addEventListener('loadeddata', () => {
                if (!settled) video.currentTime = seekTimes[0];
            });
            video.addEventListener('error', () => {
                clearTimeout(timeout);
                cleanup();
            });
            document.body.appendChild(video);
        }

        openLightbox(file, objectUrl) {
            const overlay = document.createElement('div');
            overlay.className = 'return-modal__lightbox';

            if (file.type.startsWith('video/')) {
                const video = document.createElement('video');
                video.src = objectUrl;
                video.controls = true;
                video.autoplay = true;
                video.playsInline = true;
                overlay.appendChild(video);
            } else {
                const img = document.createElement('img');
                img.src = objectUrl;
                img.alt = file.name;
                overlay.appendChild(img);
            }

            const closeBtn = document.createElement('button');
            closeBtn.className = 'return-modal__lightbox-close';
            closeBtn.type = 'button';
            closeBtn.innerHTML = '&#x2715;';
            closeBtn.addEventListener('click', () => overlay.remove());
            overlay.appendChild(closeBtn);

            // close on backdrop click
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) overlay.remove();
            });

            document.body.appendChild(overlay);
        }

        getFormData() {
            const formData = {};

            const selectedCheckboxes = Array.from(this.itemsList?.querySelectorAll('input[name="return_items"]:checked') || []);
            const selectedIds = new Set(selectedCheckboxes.map(cb => String(cb.value)));

            const selectedQuantities = {};
            selectedCheckboxes.forEach(cb => {
                const stepperInput = cb.closest('.return-modal__item-checkbox')?.querySelector('.return-modal__qty-input');
                selectedQuantities[String(cb.value)] = stepperInput ? (parseInt(stepperInput.value, 10) || 1) : null;
            });

            const toLineItem = (item) => {
                const itemId = String(item.line_item_id || item.id);
                const selectedQty = selectedQuantities[itemId] || 1;
                return {
                    line_item_id: String(item.line_item_id || item.id),
                    product_id: item.product_id ? String(item.product_id) : null,
                    variant_id: item.variant_id ? String(item.variant_id) : null,
                    title: item.title || '',
                    variant_title: item.variant_title || null,
                    quantity: selectedQty,
                    original_quantity: Number(item.quantity) || 1,
                    price: String(item.price || '0.00'),
                    image_url: (typeof item.image === 'string' ? item.image : item.image?.src) || null,
                    is_subscription: item.is_subscription === true || item.is_subscription === 'true' || false
                };
            };

            formData.line_items = this.eligibleLineItems
                .filter(item => selectedIds.has(String(item.line_item_id || item.id)))
                .map(toLineItem);

            // determine if this is a full or partial return
            // full = all eligible items selected with full quantities
            const isFullReturn = this.eligibleLineItems.length > 0 &&
                this.eligibleLineItems.length === formData.line_items.length &&
                formData.line_items.every(li => li.quantity === li.original_quantity);
            formData.return_type = isFullReturn ? 'FULL' : 'PARTIAL';

            formData.line_items_display = selectedCheckboxes.map(cb => ({
                title: cb.dataset.title,
                variant_title: cb.dataset.variantTitle
            }));

            formData.reason = this.getSelectedReason();
            formData.reason_suboption = this.getSelectedSuboption() || null;

            const detailsTextarea = this.querySelector('textarea[name="details"]');
            formData.reason_details = detailsTextarea?.value?.trim() || '';

            return formData;
        }

        buildSummary(formData) {
            if (!this.summaryContainer) return;
            this.summaryContainer.innerHTML = '';

            // order + reason rows
            const topRows = [
                { label: rt('summary_order'), value: this.orderData?.order_name || '' },
                { label: rt('summary_reason'), value: this.formatReason(formData.reason) }
            ];

            if (formData.reason_suboption) {
                topRows.push({ label: rt('summary_suboption'), value: this.formatSuboption(formData.reason_suboption) });
            }

            if (formData.reason_details) {
                topRows.push({ label: rt('summary_details'), value: formData.reason_details });
            }

            topRows.forEach(row => {
                this.summaryContainer.appendChild(this.createSummaryRow(row.label, row.value));
            });

            // items section
            if (formData.line_items && formData.line_items.length > 0) {
                const itemsLabel = document.createElement('span');
                itemsLabel.className = 'return-modal__summary-label';
                itemsLabel.textContent = rt('items_count', { count: formData.line_items.length });
                this.summaryContainer.appendChild(itemsLabel);

                const itemsList = document.createElement('div');
                itemsList.className = 'return-modal__summary-items';

                formData.line_items.forEach(item => {
                    const card = document.createElement('div');
                    card.className = 'return-modal__summary-item';

                    if (item.image_url) {
                        const img = document.createElement('img');
                        img.className = 'return-modal__summary-item-image';
                        img.src = item.image_url;
                        img.alt = item.title;
                        card.appendChild(img);
                    }

                    const info = document.createElement('div');
                    info.className = 'return-modal__summary-item-info';

                    const name = document.createElement('span');
                    name.className = 'return-modal__summary-item-name';
                    name.textContent = item.title;
                    info.appendChild(name);

                    if (item.variant_title && item.variant_title !== 'Default Title') {
                        const variant = document.createElement('span');
                        variant.className = 'return-modal__summary-item-variant';
                        variant.textContent = item.variant_title;
                        info.appendChild(variant);
                    }

                    const meta = document.createElement('div');
                    meta.className = 'return-modal__summary-item-meta';

                    const returnQty = item.quantity || 1;
                    const originalQty = item.original_quantity || returnQty;
                    const qtyText = originalQty > 1
                        ? rt('returning_qty', { returning: returnQty, total: originalQty })
                        : rt('qty_label', { quantity: returnQty });

                    const qty = document.createElement('span');
                    qty.textContent = qtyText;
                    meta.appendChild(qty);

                    if (item.price) {
                        const amount = document.createElement('span');
                        const lineTotal = (parseFloat(item.price) * returnQty).toFixed(2);
                        amount.textContent = `$${lineTotal}`;
                        meta.appendChild(amount);
                    }

                    info.appendChild(meta);
                    card.appendChild(info);
                    itemsList.appendChild(card);
                });

                this.summaryContainer.appendChild(itemsList);
            }

            // files thumbnails
            if (this.selectedFiles.length > 0) {
                const failedCount = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'failed').length;
                const filesLabel = document.createElement('span');
                filesLabel.className = 'return-modal__summary-label';
                filesLabel.textContent = `${rt('summary_files')} (${this.selectedFiles.length})`;
                this.summaryContainer.appendChild(filesLabel);

                const thumbGrid = document.createElement('div');
                thumbGrid.className = 'return-modal__upload-previews';
                thumbGrid.id = 'js-summary-upload-previews';

                this.selectedFiles.forEach((file) => {
                    const uploadInfo = this.fileUploadStatus.get(file);
                    const isFailed = uploadInfo?.status === 'failed';
                    const isUploading = uploadInfo?.status === 'uploading';

                    const wrapper = document.createElement('div');
                    wrapper.className = 'return-modal__upload-preview';
                    if (isFailed) wrapper.classList.add('return-modal__upload-preview--failed');
                    if (uploadInfo?.status === 'uploaded') wrapper.classList.add('return-modal__upload-preview--uploaded');
                    if (isUploading) {
                        wrapper.classList.add('return-modal__upload-preview--uploading');
                        const spinner = document.createElement('div');
                        spinner.className = 'return-modal__upload-preview-spinner';
                        spinner.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" stroke-width="3"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" stroke-width="3" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/></path></svg>';
                        wrapper.appendChild(spinner);
                    }

                    const objectUrl = URL.createObjectURL(file);
                    const ext = file.name.split('.').pop().toLowerCase();
                    const unsupportedVideoExts = ['avi', 'mkv', 'wmv', 'flv'];
                    const videoExts = ['mov', 'webm', 'mp4', 'm4v', '3gp', ...unsupportedVideoExts];
                    const isVideo = file.type.startsWith('video/') || videoExts.includes(ext);
                    const videoPlaceholderHtml = '<div class="return-modal__upload-preview-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 10l5-3v10l-5-3V10z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="3" y="6" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/></svg><span>' + ext.toUpperCase() + '</span></div>';

                    if (isVideo && unsupportedVideoExts.includes(ext)) {
                        // known unsupported format -- show placeholder immediately
                        wrapper.classList.add('return-modal__upload-preview--no-thumb');
                        wrapper.insertAdjacentHTML('afterbegin', videoPlaceholderHtml);
                    } else if (isVideo) {
                        this._generateVideoThumbnail(objectUrl, wrapper, videoPlaceholderHtml);
                    } else {
                        const fileExt = file.name.split('.').pop().toUpperCase();
                        const filePlaceholderHtml = '<div class="return-modal__upload-preview-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + fileExt + '</span></div>';
                        wrapper.classList.add('return-modal__upload-preview--no-thumb');
                        wrapper.insertAdjacentHTML('afterbegin', filePlaceholderHtml);
                        const img = document.createElement('img');
                        img.src = objectUrl;
                        img.alt = file.name;
                        img.addEventListener('load', () => {
                            wrapper.classList.remove('return-modal__upload-preview--no-thumb');
                            const placeholder = wrapper.querySelector('.return-modal__upload-preview-placeholder');
                            if (placeholder) placeholder.remove();
                            wrapper.insertAdjacentElement('afterbegin', img);
                        });
                    }

                    if (isFailed) {
                        const retryBtn = document.createElement('button');
                        retryBtn.className = 'return-modal__upload-preview-retry';
                        retryBtn.type = 'button';
                        retryBtn.title = rt('retry_upload_title');
                        retryBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 7a5.5 5.5 0 1 1 1.1 3.3" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/><path d="M1 4v3.5h3.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                        retryBtn.addEventListener('click', async (e) => {
                            e.stopPropagation();
                            await this.retrySingleUpload(file);
                            // rebuild summary to reflect updated status
                            this.buildSummary(this.getFormData());
                        });
                        wrapper.appendChild(retryBtn);
                    } else if (uploadInfo?.status === 'uploaded') {
                        const tick = document.createElement('span');
                        tick.className = 'return-modal__upload-preview-tick';
                        tick.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#22c55e"/><path d="M5 8l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                        wrapper.appendChild(tick);
                    }

                    wrapper.addEventListener('click', () => {
                        this.openLightbox(file, objectUrl);
                    });

                    thumbGrid.appendChild(wrapper);
                });

                this.summaryContainer.appendChild(thumbGrid);

                // show retry all button if any failed
                if (failedCount > 0) {
                    const retryAllBtn = document.createElement('button');
                    retryAllBtn.className = 'return-modal__summary-retry-all';
                    retryAllBtn.type = 'button';
                    retryAllBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 14 14" fill="none"><path d="M1.5 7a5.5 5.5 0 1 1 1.1 3.3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M1 4v3.5h3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>${rt('retry_failed_uploads', { count: failedCount })}</span>`;
                    retryAllBtn.addEventListener('click', async () => {
                        const failedFiles = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'failed');
                        for (const file of failedFiles) {
                            await this.retrySingleUpload(file);
                        }
                        this.buildSummary(this.getFormData());
                        // clear error if all succeeded
                        const stillFailed = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'failed');
                        if (stillFailed.length === 0) {
                            this.toggleError('', true);
                        }
                    });
                    this.summaryContainer.appendChild(retryAllBtn);
                }
            }
        }

        createSummaryRow(label, value) {
            const rowEl = document.createElement('div');
            rowEl.className = 'return-modal__summary-row';

            const labelEl = document.createElement('span');
            labelEl.className = 'return-modal__summary-label';
            labelEl.textContent = label;

            const valueEl = document.createElement('span');
            valueEl.className = 'return-modal__summary-value';
            valueEl.textContent = value;

            rowEl.appendChild(labelEl);
            rowEl.appendChild(valueEl);
            return rowEl;
        }

        formatReason(reason) {
            const reasonMap = {
                'TECHNICAL_ISSUE': rt('reason_technical_label'),
                'EXPECTATIONS': rt('reason_expectations_label'),
                'SPACE': rt('reason_space_label'),
                'DAMAGED_IN_SHIPPING': rt('reason_damaged_label'),
                'NO_LONGER_NEEDED': rt('reason_no_longer_needed_label'),
                'WRONG_ITEM': rt('reason_wrong_item_label')
            };
            return reasonMap[reason] || reason;
        }

        formatSuboption(suboption) {
            const suboptionMap = {
                'MAT_NOT_DETECTED': rt('suboption_mat_not_detected'),
                'ACCURACY_ISSUES': rt('suboption_accuracy_issues'),
                'APP_CRASHES_OR_FREEZES': rt('suboption_app_crashes'),
                'DEVICE_CONNECTION_ISSUES': rt('suboption_device_connection'),
                'ACCURACY_NOT_GOOD_ENOUGH': rt('suboption_accuracy_not_good_enough'),
                'SETUP_TOO_COMPLICATED': rt('suboption_setup_too_complicated'),
                'PRODUCT_FELT_DIFFERENT': rt('suboption_product_felt_different'),
                'DID_NOT_FIT_MY_NEEDS': rt('suboption_did_not_fit_needs'),
                'NOT_ENOUGH_ROOM': rt('suboption_not_enough_room'),
                'CEILING_HEIGHT_ISSUE': rt('suboption_ceiling_height'),
                'LIGHTING_ISSUE': rt('suboption_lighting'),
                'CAMERA_POSITIONING_ISSUE': rt('suboption_camera_positioning'),
                'PURCHASED_BY_MISTAKE': rt('suboption_purchased_by_mistake'),
                'RECEIVED_AS_GIFT': rt('suboption_received_as_gift'),
                'ORDERED_MORE_THAN_ONE': rt('suboption_ordered_more_than_one'),
                'NO_LONGER_INTERESTED': rt('suboption_no_longer_interested'),
                'SOMETHING_ELSE': rt('suboption_something_else')
            };
            return suboptionMap[suboption] || suboption;
        }

        getFileContentType(file) {
            return window.ReturnsUtils.getFileContentType(file);
        }

        uploadFileToS3(presignedUrl, file) {
            return window.ReturnsUtils.uploadFileToS3(presignedUrl, file);
        }

        async uploadPhotos() {
            if (this.selectedFiles.length === 0) return [];

            const keys = [];
            this._completedUploads = 0;

            // collect keys from already-uploaded files
            for (const file of this.selectedFiles) {
                const existing = this.fileUploadStatus.get(file);
                if (existing?.status === 'uploaded' && existing.key) {
                    keys.push(existing.key);
                    this._completedUploads++;
                }
            }

            // only upload pending or failed files
            const filesToUpload = this.selectedFiles.filter(file => {
                const s = this.fileUploadStatus.get(file);
                return !s || s.status !== 'uploaded';
            });

            if (filesToUpload.length === 0) return keys;

            for (const file of filesToUpload) {
                try {
                    const contentType = this.getFileContentType(file);
                    const presignedRes = await this.requestPresignedUrl(contentType);

                    if (!presignedRes.ok) {
                        this.fileUploadStatus.set(file, { status: 'failed', key: null });
                        continue;
                    }

                    const presignedData = await presignedRes.json();
                    const { presignedUrl, key } = presignedData.data || {};

                    await this.uploadFileToS3(presignedUrl, file);
                    keys.push(key);
                    this.fileUploadStatus.set(file, { status: 'uploaded', key });
                    this._completedUploads++;
                    this.renderPreviews();
                } catch (error) {
                    this.fileUploadStatus.set(file, { status: 'failed', key: null });
                    this.renderPreviews();
                }
            }
            return keys;
        }

        async retrySingleUpload(file) {
            this.fileUploadStatus.set(file, { status: 'pending', key: null });
            this.renderPreviews();

            try {
                const presignedRes = await this.requestPresignedUrl(this.getFileContentType(file));

                if (!presignedRes.ok) {
                    console.error('Failed to get presigned URL for:', file.name, '- file type may not be supported');
                    this.fileUploadStatus.set(file, { status: 'failed', key: null });
                    this.renderPreviews();
                    return;
                }

                const presignedData = await presignedRes.json();
                const { presignedUrl, key } = presignedData.data || {};

                await this.uploadFileToS3(presignedUrl, file);
                this.fileUploadStatus.set(file, { status: 'uploaded', key });
                this.uploadedPhotoKeys = this.selectedFiles
                    .map(f => this.fileUploadStatus.get(f)?.key)
                    .filter(Boolean);
            } catch (error) {
                console.error('Retry upload error:', error);
                this.fileUploadStatus.set(file, { status: 'failed', key: null });
            }

            this.renderPreviews();
        }

        async handleSubmit() {
            this.toggleError('', true);
            const btnText = this.submitButton?.querySelector('.return-modal__submit-button-content > span:first-child');
            const loader = this.submitButton?.querySelector('.loader');
            const statusEl = this.querySelector('.js-return-modal-confirm-upload-status');

            this.submitButton?.setAttribute('disabled', '');

            try {
                // phase 1: upload files
                const filesToUpload = this.selectedFiles.filter(f => {
                    const s = this.fileUploadStatus.get(f);
                    return !s || s.status !== 'uploaded';
                });

                if (filesToUpload.length > 0) {
                    if (btnText) btnText.textContent = rt('uploading');
                    this.submitButton?.classList.add(this.classes.loading);
                    loader?.classList.remove(this.classes.isHidden);

                    const total = this.selectedFiles.length;
                    const updateStatus = () => {
                        if (!statusEl) return;
                        const uploaded = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'uploaded').length;
                        const uploading = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'uploading').length;
                        if (uploading > 0) {
                            statusEl.textContent = `Uploading files: ${uploaded}/${total}`;
                        } else {
                            statusEl.textContent = uploaded === total ? `All ${total} files uploaded` : `${uploaded}/${total} uploaded`;
                        }
                    };
                    updateStatus();

                    // override renderPreviews to update summary UI during upload
                    const origRender = this.renderPreviews.bind(this);
                    this.renderPreviews = () => {
                        origRender();
                        updateStatus();
                        this.buildSummary(this.getFormData());
                    };
                    await this.uploadFilesInBackground(filesToUpload);
                    this.renderPreviews = origRender;

                    const failed = this.selectedFiles.filter(f => this.fileUploadStatus.get(f)?.status === 'failed');
                    if (failed.length > 0) {
                        const failedNames = failed.map(f => f.name).join(', ');
                        if (statusEl) statusEl.textContent = '';
                        if (btnText) btnText.textContent = rt('submit_return');
                        this.submitButton?.classList.remove(this.classes.loading);
                        loader?.classList.add(this.classes.isHidden);
                        this.submitButton?.removeAttribute('disabled');
                        this.toggleError(`${failed.length} file(s) failed to upload (${failedNames}). Please try again.`, false);
                        return;
                    }
                }

                this.uploadedPhotoKeys = this.selectedFiles
                    .map(f => this.fileUploadStatus.get(f)?.key)
                    .filter(Boolean);

                // phase 2: submit return
                if (statusEl) statusEl.textContent = '';
                if (btnText) btnText.textContent = rt('submitting');
                this.submitButton?.classList.add(this.classes.loading);
                loader?.classList.remove(this.classes.isHidden);

                const formData = this.getFormData();

                const payload = {
                    return_type: formData.return_type,
                    reason: formData.reason,
                    reason_details: formData.reason_details,
                    photo_keys: this.uploadedPhotoKeys,
                    line_items: formData.line_items,
                    has_shipping_protection: this.orderData?.has_shipping_protection === true,
                };
                if (formData.reason_suboption) {
                    // only reasons with a suboption set may carry one; the api
                    // rejects the field on reasons without a set
                    payload.reason_suboption = formData.reason_suboption;
                }
                if (!this.publicToken) {
                    // the public submit schema is strict: order identity comes
                    // from the token row, so these fields exist only for the
                    // logged-in endpoint
                    payload.shopify_order_id = this.shopifyOrderId || this.orderData?.order_id;
                    payload.shopify_order_name = this.shopifyOrderName || this.orderData?.order_name;
                    payload.order_created_at = this.orderData?.created_at ? new Date(Number(this.orderData.created_at) * 1000).toISOString() : undefined;
                    payload.order_fulfilled_at = this.orderData?.fulfilled_at ? new Date(Number(this.orderData.fulfilled_at) * 1000).toISOString() : undefined;
                }

                const submitUrl = this.publicToken
                    ? this.publicEndpoint('/submit')
                    : `${this.API_BASE}/returns/submit`;
                const response = await this.apiCall(submitUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                if (response.ok) {
                    const data = await response.json();
                    const result = data.data || {};

                    this.submittedReturnId = result.return_id || null;

                    if (this.successReturnId) {
                        this.successReturnId.textContent = result.display_return_id || result.return_id || '';
                    }
                    if (this.successText) {
                        this.successText.textContent = rt('return_being_reviewed');
                    }

                    this.goToStep('success');

                    // soft-update the page: hide button, update status badge, reload return details
                    if (this.orderData?.order_name) {
                        document.dispatchEvent(new CustomEvent('return-submitted', {
                            detail: { orderName: this.orderData.order_name }
                        }));
                    }

                    // account-returns:load is handled by return-submitted with a delay
                } else if (this.publicToken && response.status === 410) {
                    this.toggleError('This return link has expired. Please contact support for a new one.', false);
                } else {
                    const errorData = await response.json().catch(() => null);
                    this.toggleError(errorData?.message || rt('submit_failed'), false);
                }
            } catch (error) {
                console.error('Return submit error:', error);
                this.toggleError(rt('something_went_wrong'), false);
            } finally {
                if (btnText) btnText.textContent = rt('submit_return');
                this.submitButton?.classList.remove(this.classes.loading);
                this.submitButton?.removeAttribute('disabled');
                loader?.classList.add(this.classes.isHidden);
            }
        }

        // -- rating widget methods --

        resetRatingWidget() {
            this.querySelectorAll('.js-return-modal-star').forEach(s => {
                s.classList.remove('selected', 'hovered');
            });
            this.ratingFeedback?.classList.add('hidden');
            this.ratingThankyou?.classList.add('hidden');
            this.ratingTrustpilot?.classList.add('hidden');
            this.ratingStars?.classList.remove('hidden');
            const textarea = this.ratingFeedback?.querySelector('textarea');
            if (textarea) textarea.value = '';
            const prompt = this.querySelector('.return-modal__rating-prompt');
            if (prompt) prompt.classList.remove('hidden');
        }

        handleStarHover(e) {
            const star = e.currentTarget;
            const value = parseInt(star.dataset.value, 10);
            this.querySelectorAll('.js-return-modal-star').forEach(s => {
                const v = parseInt(s.dataset.value, 10);
                s.classList.toggle('hovered', v <= value);
            });
        }

        handleStarLeave() {
            this.querySelectorAll('.js-return-modal-star').forEach(s => {
                s.classList.remove('hovered');
            });
        }

        handleStarClick(e) {
            const star = e.currentTarget;
            const value = parseInt(star.dataset.value, 10);
            this.selectedRating = value;

            // update visual state
            this.querySelectorAll('.js-return-modal-star').forEach(s => {
                const v = parseInt(s.dataset.value, 10);
                s.classList.toggle('selected', v <= value);
            });

            // hide prompt text
            const prompt = this.querySelector('.return-modal__rating-prompt');
            if (prompt) prompt.classList.add('hidden');

            if (value <= 2) {
                // low rating: show feedback textarea
                this.ratingFeedback?.classList.remove('hidden');
                this.ratingThankyou?.classList.add('hidden');
                this.ratingTrustpilot?.classList.add('hidden');
            } else if (value <= 4) {
                // 3-4 stars: submit immediately, show thank you
                this.ratingFeedback?.classList.add('hidden');
                this.ratingTrustpilot?.classList.add('hidden');
                this.submitRatingToApi(value, null);
                this.showRatingComplete('thankyou');
            } else {
                // 5 stars: temporarily behaves like 3-4 stars (thank you, no
                // trustpilot cta). to re-enable trustpilot, restore this block:
                // this.ratingFeedback?.classList.add('hidden');
                // this.ratingThankyou?.classList.add('hidden');
                // this.submitRatingToApi(value, null);
                // this.showRatingComplete('trustpilot');
                this.ratingFeedback?.classList.add('hidden');
                this.ratingTrustpilot?.classList.add('hidden');
                this.submitRatingToApi(value, null);
                this.showRatingComplete('thankyou');
            }
        }

        handleRatingSubmit() {
            const textarea = this.ratingFeedback?.querySelector('textarea');
            const comment = textarea?.value?.trim() || '';
            this.submitRatingToApi(this.selectedRating, comment || null);
            this.showRatingComplete('thankyou');
        }

        showRatingComplete(type) {
            // hide stars and feedback form
            this.ratingStars?.classList.add('hidden');
            this.ratingFeedback?.classList.add('hidden');

            if (type === 'trustpilot') {
                this.ratingTrustpilot?.classList.remove('hidden');
                this.ratingThankyou?.classList.add('hidden');
            } else {
                this.ratingThankyou?.classList.remove('hidden');
                this.ratingTrustpilot?.classList.add('hidden');
            }
        }

        async submitRatingToApi(rating, comment) {
            if (!this.submittedReturnId) return;

            try {
                const feedbackUrl = this.publicToken
                    ? this.publicEndpoint('/feedback')
                    : `${this.API_BASE}/returns/${this.submittedReturnId}/feedback`;
                await this.apiCall(feedbackUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ rating, comment })
                });
            } catch (err) {
                console.error('Failed to submit return feedback:', err);
            }
        }
    });
}
